const talent = {
  addToTag: '添加到标签',
  selectTag: '选择目标标签',
  removeFromCurrentTag: '同时从当前标签移除（转移）',
  transfer: '转移人才',
  name: '名字',
  basicInfo: '基本信息',
  profile: '个人档案',
  contact: '联系方式',
  remark: '备注',
  get: '获取',
  copySuccess: '复制成功',
  fetchSuccess: '获取成功',
  fetchFailed: '获取失败',
  unlockContactWithCost: '消耗 {count} 联系积分解锁',
  insufficientContactPoints: '联系积分不足',
  noUnlockableContact: '暂无可解锁联系方式',
  expand: '展开',
  collapse: '收起',
  talentPoolPageDesc: '选择一个人才库后，集中查看候选人状态、联系方式和批量操作。',
  talentGroups: '人才分组',
  groupRightClickHint: '可右键编辑标签',
  searchGroupPlaceholder: '搜索分组',
  collapseGroupMenu: '收起菜单',
  expandGroupMenu: '展开菜单',
  unselectedBreadcrumb: '未选择人才库',
  unselectedTitle: '请在左边菜单选择人才分组',
  unselectedDesc: '从左侧选择全部人才或某个人才分组后，这里会展示状态概览、筛选器和候选人列表。',
  unselectedHints: {
    aiMatch: 'AI 智能匹配',
    quickFilter: '一键筛选',
    batchManage: '批量管理',
  },
  viewAllTalents: '查看全部人才',
  createGroup: '新建分组',
  apolloImportButton: '导入 Apollo',
  apolloImportTitle: '导入 Apollo 联系人',
  apolloImportUploadTitle: '上传 Apollo CSV',
  apolloImportUploadDesc:
    '读取 Apollo 导出的联系人 CSV，只导入 LinkedIn、姓名、邮箱和手机号，不触发简历清洗。',
  apolloImportDropTitle: '拖入 CSV 或点击选择',
  apolloImportDropDesc: '支持 Apollo contacts export .csv',
  apolloImportReset: '重新选择',
  apolloImportTagName: '保存到标签',
  apolloImportTagPlaceholder: '输入新标签名称，已存在则复用',
  apolloImportTotalRows: '总行数',
  apolloImportReadyRows: '可导入',
  apolloImportSkippedRows: '跳过',
  apolloImportPreviewTitle: '导入预览',
  apolloImportPreviewDesc: '最多展示前 50 行，缺少 LinkedIn 或重复 LinkedIn 的行会跳过。',
  apolloImportColumnRow: '行号',
  apolloImportColumnTitle: '职位',
  apolloImportColumnStatus: '状态',
  apolloImportStatusReady: '可导入',
  apolloImportStatusDuplicate: '重复',
  apolloImportStatusSkipped: '跳过',
  apolloImportSubmit: '导入联系人',
  apolloImportParsing: '正在解析...',
  apolloImportProgressReading: '正在读取文件',
  apolloImportProgressParsing: '正在解析 CSV',
  apolloImportProgressRows: '正在提取表格行',
  apolloImportProgressNormalizing: '正在整理联系人字段',
  apolloImportProgressDone: '解析完成',
  apolloImportInvalidFile: '请上传 CSV 文件',
  apolloImportParseFailed: 'CSV 解析失败，请检查文件格式',
  apolloImportFailed: '联系人导入失败，请稍后重试',
  apolloImportSuccess: '导入完成：新建 {created}，更新 {updated}，跳过 {skipped}',
  createGroupTitle: '新建人才分组',
  createGroupHint: '用于归档候选人和后续批量筛选，名称长度 1-64 个字符。',
  groupName: '分组名称',
  groupNamePlaceholder: '请输入分组名称',
  groupNameLengthMessage: '分组名称需为 1-64 个字符',
  defaultGroupBadge: '默认',
  defaultGroupLocked: '默认人才库不可修改',
  emptyGroups: '暂无匹配分组',
  loadingGroups: '正在加载分组...',
  loadMoreGroups: '加载更多分组',
  addFriend: '添加好友',
  confirmDelete: '确定要将该候选人从当前人才库中移除吗？',
  confirmDeleteRemark: '确定删除该备注吗？',
  chinese: '华人',
  chinaExperience: '中企经历',
  year: '年',
  durationYear: '年',
  durationMonth: '个月',
  present: '至今',
  company: '公司',
  companyPlaceholder: '请输入公司名称',
  phone: '电话',
  phonePlaceholder: '请输入电话号码',
  phoneActionsTitle: '前往 WhatsApp 网页版',
  copyPhone: '复制号码',
  openWhatsApp: '打开 WhatsApp 网页版',
  whatsAppOpenNotice: '此操作只会打开 WhatsApp 网页版，不会自动发送任何消息。',
  whatsAppCountryLabel: '号码国家/地区',
  whatsAppTargetPhoneLabel: '目标手机号',
  whatsAppMultiplePhonesCount: '检测到 {count} 个电话，请选择',
  whatsAppQuickMultipleTitle: 'WhatsApp (已检测到 {count} 个可用电话)',
  whatsAppPhoneInputPlaceholder: '请输入或调整手机号',
  whatsAppPhoneEditHint: '可直接修改号码（如去除多余备注或字符），仅用于本次沟通，不改变原始数据',
  whatsAppCountryPlaceholder: '请选择国家或地区',
  whatsAppCountrySearchPlaceholder: '搜索国家、地区或区号 (如 中国、86、CN)...',
  whatsAppCountryRequired: '无法自动识别号码区号，请先选择国家或地区',
  whatsAppAccessRequired: '请联系销售开通此功能',
  whatsAppMessageLabel: '预填消息（不会自动发送）',
  whatsAppMessagePlaceholder: '输入需要带到 WhatsApp 的消息',
  whatsAppMessageHint:
    '消息会停留在输入框中，需要你在 WhatsApp 内确认并手动发送；清空后仅打开聊天。',
  whatsAppDefaultMessage: '你好，{name}，我是招聘人员，想和你沟通一个工作机会。',
  whatsAppInvalidPhone: '手机号格式无效，无法打开 WhatsApp',
  email: '邮箱',
  emailPlaceholder: '请输入邮箱',
  namePlaceholder: '请输入姓名',
  location: '地区',
  locationParent: '国家/地区',
  locationChild: '省份/州',
  age: '年龄',
  hasChinaExperience: '有中企经历',
  eduLevel: '学历要求',
  qsRanking: '全球QS排名',
  majorType: '专业类型',
  notePlaceholder: '请输入备注信息...',
  saveNote: '保存备注',
  editNote: '编辑备注',
  deleteNote: '删除备注',
  noteList: '备注列表',
  addNote: '添加备注',
  jobHoppingFrequency: '工作跳槽频率',
  jobHopping: {
    Max3JobsIn5Years: '5年内最多3份工作',
    Max2JobsIn3Years: '3年内最多2份工作',
    Min2YearsInLast2Jobs: '最近2份工作至少2年',
    NoLimit: '不限',
  },
  nationality: '国籍',
  foreigner: '外籍',
  nonChinese: '非华人',
  source: {
    manual: 'LinkedIn',
    upload: 'LinkedIn',
    tag_import: 'LinkedIn',
    linkedin: 'LinkedIn',
    automation_import: '自动化导入',
    talent_recommendation: '人才推荐',
  },
  // Options
  bachelor: '本科',
  master: '硕士',
  mba: 'MBA',
  doctorate: '博士',
  secondary: '中学',
  associate: '专科',
  postdoc: '博士后',
  top100: 'Top 100',
  top200: 'Top 200',
  top300: 'Top 300',
  language: '语言',
  contactMethods: '联系方式',
  contactMethodEmail: '已有邮箱',
  sendEmail: '发送邮件',
  emailHistory: '历史',
  emailHistoryLoading: '正在加载邮件历史...',
  emailHistoryEmpty: '暂无邮件记录',
  emailSubjectEmpty: '无主题',
  emailBodyEmpty: '暂无正文',
  emailStatus: {
    pending: '待发送',
    sent: '已发送',
    goback: '已退回',
    failed: '发送失败',
    warning: '发送警告',
  },
  contactMethodPhone: '已有手机号',
  contactMethodWechat: '微信',
  contactMethodGithub: 'GitHub',
  contactMethodTwitter: 'Twitter',
  contactMethodFacebook: 'Facebook',
  contactMethodInstagram: 'Instagram',
  contactMethodTiktok: 'TikTok',
  contactMethodLinkedin: 'LinkedIn',
  function: '职能',
  statusFilter: '状态',
  added: '已添加',
  unsent: '未发送请求',
  waiting: '等待验证',
  openToWork: '有意向看机会',
  active: '活跃',
  vipRequired: '请开通会员身份',
  chinaIdentityMembershipRequired: '请开通会员查看',
  chineseStatusField: '是否华人',
  chinaExperienceStatusField: '是否有中企经历',
  chinaIdentityMembershipLockedTooltip: '请开通会员身份，查看{field}',
  chinaIdentityCreditsLockedTooltip: 'AI积分不足，无法查看{field}',
  vipRequiredForFilter: '请开通会员身份进行筛选',
  linkedinBindRequiredForFilter: '请先在个人中心绑定 LinkedIn 账号后再进行状态筛选',
  greeting: '留言',
  useTemplate: '使用模板',
  defaultGreeting: '你好 {name}，我对你的经历很感兴趣...',
  noEncodedId: '未找到该候选人的 LinkedIn ID',
  greetingPlaceholder: '请输入打招呼内容...',
  sendWithoutNote: '不留言直接发送',
  connectTimeout: '请求超时，请稍后重试',
  connectSuccess: '打招呼成功！',
  connectLimitExceeded: '今日添加好友次数已达上限',
  connectInviteLimitReached: 'LinkedIn 邀请额度已达上限，请稍后再试或更换账号',
  connectInviteLimitReachedForCandidate:
    '您向{name}发送的邀请未成功，因为您已达到 LinkedIn 每周连接邀请的上限。请下周再试。',
  connectInviteLimitConfirm: '确认',
  connectInviteLimitViewSent: '查看已发送 ↗',
  connectFailed: '打招呼失败：{error}',
  connectAlreadyAddedSyncHint:
    '当前候选人已是 LinkedIn 好友或处于 Pending 状态，请到 LinkedIn 页面点击一键同步状态按钮。',
  linkedinAccountNotLinked:
    '当前 LinkedIn 平台账号与 EasyHireAI 账号绑定不符，请先切换或重新绑定后再继续。',
  syncLinkedinStatusFailed: '同步 LinkedIn 发送状态失败，请稍后重试。',
  extensionRequired: '请先开启 EasyHireAI 插件后再发送打招呼',
  extensionStatus: '状态',
  extensionChecking: '检测中',
  extensionConnected: '已连接',
  extensionMissing: '未连接',
  extensionRetry: '重新检测',
  extensionHint: '请确保已安装并开启 EasyHireAI 插件，然后刷新页面或重新打开弹窗',
  batchAddFiltered: '已过滤 {count} 个已添加/等待验证的候选人',
  batchAddInvalidSelection: '所选候选人已添加或等待验证，无法批量添加',
  addFriendNoFsdProfile: '当前候选人缺少 LinkedIn fsd_profile 识别码，无法添加好友',
  batchAddFilteredNoFsdProfile: '已自动过滤 {count} 位缺少有效识别码或已添加的候选人',
  batchAddInvalidNoFsdProfile: '所选候选人均缺少有效识别码或已添加，无法批量添加',
  selectCandidatesFirst: '请先选择表格中的候选人',
  inMailDialogTitle: '新建 InMail',
  inMailSelectedSummary: '已选 {count} 位候选人，将按同一草稿发送',
  inMailSubject: '主题',
  inMailSubjectPlaceholder: '请输入 InMail 主题',
  inMailMessage: '消息内容',
  inMailMessagePlaceholder: '请输入你的 InMail 内容...',
  inMailIncomplete: '请先填写主题和消息内容',
  inMailDraftReady: 'InMail 草稿已生成',
  aiInMailGoal: '目标',
  aiInMailGoalExplore: '了解意向',
  aiInMailGoalInterest: '约时间沟通',
  aiInMailGoalForward: '索要简历',
  aiInMailLanguage: '语言',
  aiInMailLanguageAuto: '自动',
  aiInMailLanguageEnglish: '英文',
  aiInMailLanguageChinese: '中文',
  aiInMailRecruiterRefreshHint: '若发送失败，请在 Recruiter 项目中刷新一下页面后重试。',
  aiInMailSubject: '主题',
  aiInMailGeneratedMessage: 'AI 生成消息',
  aiInMailGenerating: '生成中',
  aiInMailGeneratingShort: '生成中',
  aiInMailRegenerate: '重新生成',
  aiInMailStartGenerate: '开始生成',
  aiInMailNoCandidateSelected: '请先在下方勾选候选人',
  aiInMailSending: '正在发送 InMail...',
  aiInMailSendingTo: '正在发送给 {name}',
  aiInMailSendingRemaining: '剩余 {count} 人',
  aiInMailGenerateFailed: 'InMail 生成失败，请稍后重试',
  aiInMailMembershipRequired: '请开通会员获取 AI 积分',
  aiInMailInsufficientCredits: 'AI 积分不足，请充值或升级会员后重试',
  aiInMailGenerateFailedShort: '生成失败',
  aiInMailSend: '发送 InMail',
  aiInMailButton: 'AI InMail',
  batchAiInMailButton: '批量AI InMail',
  aiInMailNoTsProfile: '当前候选人缺少 LinkedIn ts_profile，暂时无法发送 InMail',
  aiInMailFilteredNoTsProfile: '已自动过滤 {count} 位缺少 LinkedIn ts_profile 的候选人',
  aiInMailNoSendableCandidates: '当前没有可发送 InMail 的候选人',
  aiInMailSendSuccess: 'InMail 发送成功，共 {count} 人',
  aiInMailSendResult: 'InMail 发送结果：成功 {success} 人，失败 {failed} 人，未确认 {unknown} 人',
  aiInMailSendFailed: 'InMail 发送失败，请检查 LinkedIn 登录状态及账号权限',
  aiInMailSendUnconfirmed: '发送结果未确认，请到 LinkedIn 核实后再决定是否重发',
  aiInMailLinkedInRejected: 'LinkedIn 返回业务错误，发送失败；请在 LinkedIn 查看具体限制',
  aiInMailNoCredits: 'LinkedIn InMail 额度不足，发送失败',
  aiInMailRecipientRestricted: '该收件人无法接收 InMail，发送失败',
  aiInMailDisabledSending: 'InMail 正在发送中，请稍候',
  aiInMailDisabledExtension: '插件未连接，暂时无法发送 InMail',
  aiInMailDisabledSubject: '缺少 InMail 主题，暂时无法发送',
  aiInMailDisabledMessage: '缺少 InMail 正文，暂时无法发送',
  aiInMailDisabledGenerating: 'InMail 正在生成中，请等待所有候选人生成完成后再发送',
  aiInMailDisabledDraftsIncomplete: '请先为所有已选候选人生成完整 InMail 后再发送',
  aiInMailDisabledMissingIdentifier:
    '有 {count} 位候选人缺少 LinkedIn ts_profile，暂时无法发送 InMail',
  aiInMailPreflightFailed: '无法发送，请检查会员状态及候选人档案。',
  aiInMailSentAt: 'InMail 已发送：{time}（UTC+8）',
  tagJoinedAt: '加入当前标签：{time}（UTC+8）',
  aiInMailSentStatusSaveFailed: 'InMail 已发送，但发送记录保存失败，请勿重复发送。',
  aiInMailSentNote: '已发送 InMail，主题：{subject}',
  aiInMailSentNoteWithResource: '已发送 InMail，主题：{subject}，会话：{resourceKey}',
  aiInMailConfigHint: '先确认 InMail 配置，后续生成消息将自动带入',
  aiInMailGoFill: '去填写',
  aiInMailSignature: '署名',
  aiInMailSignaturePlaceholder: '请输入署名',
  aiInMailAdditionalInfo: '补充信息',
  aiInMailAdditionalInfoPlaceholder:
    '例如：地点、薪酬范围、工作模式、语言要求、签约方式、是否接受出差、能否现场办公、能否以中文作为沟通能力、补充在InMail的任何信息',
  aiInMailSaveDefault: '保存为默认',
  aiInMailDefaultConfigLabel: 'InMail 配置：',
  aiInMailEditConfig: '修改',
  aiInMailEditAdditionalInfo: '修改补充内容',
  aiInMailEditingHint: '编辑中',
  aiInMailCandidates: '候选人',
  aiInMailSelectedCount: '已选 {selected}/{total} 人',
  aiInMailSearchCandidates: '搜索候选人...',
  aiInMailColumnName: '姓名',
  aiInMailColumnCurrentTitle: '当前职位',
  aiInMailColumnCompany: '公司',
  aiInMailColumnLocation: '地点',
  aiInMailColumnPreview: '预览',
  aiInMailPreviewButton: '预览 InMail',
  aiInMailPreviewMessage: '预览消息',
  aiInMailEmptyCandidates: '没有匹配的候选人',
  aiInMailSignatureUnset: '--',
  aiInMailBestRegards: 'Best regards,',
  aiInMailFallbackName: '你好',
  batchSendProgress: '发送进度',
  batchSendProgressSummary: '已发送 {sent}/{total} · 成功 {success} · 失败 {failed}',
  batchSendEta: '预计剩余 {eta}',
  batchSendEtaSeconds: '{seconds} 秒',
  batchSendEtaMinutes: '{minutes} 分 {seconds} 秒',
  batchSendEtaHours: '{hours} 小时 {minutes} 分',
  batchFetchContact: '一键获取联系方式',
  batchFetchSelected: '获取已选人才',
  batchFetchCurrentJob: '获取当前岗位全部',
  batchFetchTag: '获取整个标签',
  batchFetchType: {
    all: '邮箱+手机号',
    phone: '手机号',
    email: '邮箱',
  },
  batchFetchTypedOption: '{scope} · {type}',
  batchFetchNoPermission: '当前账号没有联系方式获取权限',
  noPermissionReLoginNotice: '当前账号暂无此操作权限，请开通企业会员或联系销售',
  permissionRefreshed: '权限已刷新，请继续操作',
  batchFetchNoSelection: '请先勾选需要获取的人才',
  batchFetchDialogTitle: '批量获取联系方式',
  batchFetchModeSelected: '当前表格已选',
  batchFetchModeCurrentJob: '当前岗位全部',
  batchFetchModeTag: '整个标签',
  batchFetchPreparing: '正在计算可获取名单...',
  batchFetchPlanSummary: '共 {total} 人，可获取 {fetchable} 人（预计消耗 {points} 积分）',
  batchFetchAlreadyHas: '已跳过 {count} 人（已包含目标联系方式）',
  batchFetchInsufficient: '积分不足，已过滤 {count} 人',
  batchFetchNeedPoints: '当前积分：{points}',
  batchFetchEmpty: '暂无可获取联系方式的人才',
  batchFetchConfirm: '开始获取',
  batchFetchRunning: '正在批量获取联系方式...',
  batchFetchResult: '批量获取完成，成功 {success} 人，暂无 {failed} 人',
  batchFetchCurrentJobLoadingFailed: '加载当前岗位候选人失败，请稍后重试',
  batchFetchTagLoadingFailed: '加载标签人才失败，请稍后重试',
  batchFetchApolloEmail: '批量获取邮箱',
  batchFetchApolloEmailNoSelection: '请先勾选需要获取邮箱的人才',
  batchFetchApolloEmailEmpty: '已选人才都已有邮箱，无需重复获取',
  batchFetchApolloEmailRunning: '正在通过 Apollo 批量获取邮箱...',
  batchFetchApolloEmailResult:
    'Apollo 邮箱获取完成，成功 {success} 人，跳过 {skipped} 人，暂无 {failed} 人',
  batchFetchApolloEmailFailed: 'Apollo 批量获取邮箱失败，请稍后重试',
  batchFetchProviderEmail: '批量获取邮箱',
  batchFetchProviderEmailRunning: '正在通过 {provider} 批量获取邮箱...',
  batchFetchProviderEmailResult:
    '{provider} 邮箱获取完成，成功 {success} 人，跳过 {skipped} 人，暂无 {failed} 人',
  batchFetchProviderEmailFailed: '{provider} 批量获取邮箱失败，请稍后重试',
  contactProviderApollo: 'Apollo',
  contactProviderContactout: 'AI搜索',
  contactProviderLeadContact: 'LeadContact',
  batchSendEmail: '批量发送邮件',
  oneClickBatchSendEmail: '一键批量发送邮件',
  batchEmailNoData: '当前页暂无可发送邮件的人才',
  batchEmailSelectedNoEmail: '已选候选人中没有可发送邮件的邮箱',
  batchEmailConfig: '邮箱配置',
  batchEmailMode: '发送模式',
  batchEmailModeTemplate: '模板发送',
  batchEmailModeCustom: '自定义发送',
  batchEmailPreview: '预览邮件',
  batchEmailPreviewRecipients: '收件人数',
  batchEmailPreviewMode: '模式',
  batchEmailPreviewModeTemplate: '模板',
  batchEmailPreviewModeCustom: '自定义',
  batchEmailTemplate: '邮件模板',
  batchEmailSubject: '邮件标题',
  batchEmailSubjectPlaceholder: '请输入邮件标题',
  batchEmailBody: 'HTML 正文',
  batchEmailBodyPlaceholder: '<p>你好，我们有一个岗位可能适合你。</p>',
  batchEmailSelectConfig: '请选择邮箱配置',
  batchEmailSelectTemplate: '请选择邮件模板',
  batchEmailIncomplete: '请填写邮件标题和正文',
  batchEmailFiltered: '已自动过滤 {count} 位无邮箱候选人',
  batchEmailSubmitted: '批量邮件发送请求已提交',
  batchEmailLoadFailed: '加载邮件配置失败，请稍后重试',
  batchEmailSendFailed: '批量发送邮件失败，请稍后重试',
  batchEmailProgressMeta: '成功 {success} / 失败 {failure} / 待处理 {pending} / 警告 {warning}',
  batchEmailResultMixed: '邮件发送完成，成功 {success}，失败 {failure}，警告 {warning}',
  batchEmailResultWarning: '邮件发送完成，成功 {success}，警告 {warning}',
  batchEmailResultPanelTitle: '发送结果',
  batchEmailResultSummary: '成功 {success}，失败 {failure}，警告 {warning}',
  batchEmailResultSuccess: '成功',
  batchEmailResultFailure: '失败',
  batchEmailResultWarningCount: '警告',
  batchEmailResultStatusSent: '已发送',
  batchEmailResultStatusFailed: '失败',
  batchEmailResultStatusWarning: '警告',
  batchEmailResultFilterAll: '全部',
  batchEmailResultFilterFailed: '仅看失败',
  batchEmailResultFilterSent: '仅看成功',
  batchEmailResultFilterWarning: '仅看警告',
  batchEmailResultExportFailed: '导出失败名单',
  batchEmailResultRetryFailed: '重试失败对象',
  batchEmailResultColumnCandidate: '候选人',
  batchEmailResultColumnEmail: '邮箱',
  batchEmailResultColumnStatus: '状态',
  batchEmailResultColumnReason: '结果说明',
  batchEmailResultEmpty: '当前筛选下没有结果',
  batchEmailResultFooterTip: '发送完成后可筛选结果、导出失败名单或重试失败对象。',
  batchEmailRetryingFailed: '正在重试失败对象...',
  batchEmailRetryFailed: '重试失败对象时出错，请稍后重试。',
  batchEmailConfigPanelTitle: '发送配置',
  batchEmailConfigPanelDesc: '选择发件配置、发送模式和模板内容。',
  batchEmailTargetsTitle: '候选人预览',
  batchEmailTargetsDesc: '本次将向 {count} 位候选人发送邮件。',
  emailNoConfig: '尚未绑定发件邮箱，正在跳转到邮箱配置页',
  emailLoadPreviewFailed: '加载邮件预览失败',
  emailLoadHistoryFailed: '加载邮件历史失败',
  emailSelectConfig: '请选择邮箱配置',
  emailSelectTemplate: '请选择邮件模板',
  emailSelectSenderConfig: '请选择发件配置',
  emailAddConfig: '+ 新增邮件配置',
  emailUnnamedConfig: '未命名配置',
  emailUnnamedTemplate: '未命名模板',
  emailCandidateLabel: '候选人',
  emailRecipientLabel: '收件邮箱',
  emailRecipientMissing: '未找到可用收件邮箱',
  emailPlaceholderLabel: '占位符:',
  emailPlaceholderExample: "eg：你好{'{{name}}'} = 你好 Clement Hu",
  emailSaveTemplate: '保存模板',
  emailPreviewLoading: '预览中...',
  emailPreviewEmptySubject: '未填写邮件主题',
  emailPreviewEmptyBody: '暂无邮件正文',
  emailPreparingSend: '准备发送...',
  emailPrepareFullContent: '请先准备完整的邮件主题和正文',
  emailSent: '邮件已发送',
  emailSendFailed: '发送失败',
  emailSendProgressDefault: 'AI 正在处理邮件发送',
  emailTemplateSaved: '模板已保存',
  emailTemplateSaveFailed: '保存模板失败',
  emailCandidateInvalid: '候选人 ID 无效，无法发送邮件',
  batchEmailProgressDefault: 'AI 正在处理中',
  batchEmailStageConfig: '获取配置',
  batchEmailStageParse: '解析内容',
  batchEmailStageCandidates: '确认候选人',
  batchEmailStageCompose: '生成邮件',
  batchEmailStageSend: '发送邮件',
  batchEmailStageSummary: '汇总结果',
  gmailDirectConfigLabel: '已连接 Gmail（Beta）',
  gmailDirectSending: '正在通过已连接的 Gmail 直接发送...',
  gmailDirectSent: 'Gmail 已发送',
  gmailDirectSenderMissing: '当前账号缺少可用的 Gmail 发件地址',
  emailPreview: '邮件预览',
  exportExcel: '导出 Excel',
  exportCurrentPage: '导出当前页',
  exportCurrentJobAll: '导出当前岗位全部',
  exportAll: '导出全部',
  exportFiltered: '导出当前筛选结果',
  exportSelected: '导出已勾选',
  exportNoData: '暂无可导出的人才',
  exportNoSelection: '请先勾选需要导出的人才',
  exportFailed: '导出失败，请稍后重试',
  exportProgressTitle: '正在导出',
  exportProgressKicker: '导出任务',
  exportProgressAiKicker: 'AI 智能导出中',
  exportProgressHint: '请稍候，系统正在整理并生成导出文件。',
  exportProgressAiAllHint: 'AI 正在整理当前标签中的人才数据，请稍候。',
  exportProgressAiFilterHint: 'AI 正在整理当前筛选结果，请稍候。',
  exportProgressAiJobHint: 'AI 正在整理当前岗位下的候选人数据，请稍候。',
  exportProgressPermission: '正在校验导出权限...',
  exportProgressPrepare: '正在准备导出数据...',
  exportProgressTag: '正在汇总当前标签数据...',
  exportProgressFilter: '正在整理当前筛选结果...',
  exportProgressCollect: '正在持续整理导出内容，请稍候...',
  exportProgressBuild: '正在生成 Excel 表格...',
  exportProgressRows: '正在写入表格内容...',
  exportProgressFile: '正在打包导出文件...',
  exportProgressDownload: '正在触发浏览器下载...',
  exportProgressDone: '导出完成',
  exportCurrentPageSuccess: '当前页已导出，共 {count} 人',
  exportCurrentJobAllSuccess: '当前岗位全部候选人已导出，共 {count} 人',
  exportAllSuccess: '全部人才已导出，共 {count} 人',
  exportFilteredSuccess: '当前筛选结果已导出，共 {count} 人',
  exportSelectedSuccess: '已导出勾选人才，共 {count} 人',
  batchAddToJob: '批量添加至岗位',
  batchAddToJobTitle: '批量添加候选人至岗位',
  batchAddToJobSelectJob: '请选择目标岗位',
  batchAddToJobPlaceholder: '请选择岗位',
  batchAddToJobConfirm: '确认添加',
  batchAddToJobRunning: '正在批量添加候选人至岗位...',
  batchAddToJobResult: '批量添加完成，成功 {success} 人，失败 {failed} 人',
  batchAddToJobNoSelection: '请先选择目标岗位',
  batchRemoveFromJob: '移出当前岗位',
  batchRemoveFromJobDialogTitle: '批量移出岗位',
  batchRemoveFromJobConfirm: '确定要将这些候选人从当前岗位中移除吗？',
  batchRemoveFromJobResult: '移出岗位完成，成功 {success} 人，失败 {failed} 人',
  batchRemoveFromJobFailed: '移出当前岗位失败，请稍后重试',
  exportSheetTitle: 'EasyHireAI 人才导出报表',
  exportTagLabel: '标签',
  exportByLabel: '导出人',
  exportGeneratedAt: '导出时间',
  exportSummaryTitle: 'EasyHireAI 人才统计概览',
  exportSummarySheetName: '统计概览',
  exportSummaryTotalCandidates: '人才总数',
  exportSummaryLocationTypes: '覆盖地区数',
  exportSummaryCompanyTypes: '涉及公司数',
  exportSummarySalesShareTitle: '销售人才占比',
  exportSummaryLevelShareTitle: '匹配等级分布',
  exportSummaryLocationShareTitle: '地区人才占比',
  exportSummaryCompanyShareTitle: '公司人才占比',
  exportSummaryLabel: '维度',
  exportSummaryCount: '人数',
  exportSummaryShare: '占比',
  exportSummarySalesLabel: '销售相关',
  exportSummaryNonSalesLabel: '非销售相关',
  exportSummaryUnknownRoleLabel: '岗位未知',
  exportSummaryOthers: '其他',
  exportSummaryUnknown: '未知',
  exportSheetName: '人才报表',
  exportAge: '年龄',
  exportCurrentRole: '当前岗位',
  exportOpenToWork: 'Open to Work',
  exportActiveStatus: '活跃状态',
  exportFriendStatus: '好友状态',
  exportLatestCompany: '最近公司',
  exportCombinedExperience: '最近工作经验与教育经历',
  exportUnknown: '未知',
  exportDurationYear: '{count}年',
  exportDurationMonth: '{count}个月',
  workYears: '工龄',
  latestExperience: '工作经历',
  latestEducation: '教育经历',
  exportAnalysisScore: '匹配分数',
  exportAnalysisLevel: '匹配等级',
  exportAnalysisStrengths: '匹配优势',
  exportAnalysisRisks: '匹配风险',
  exportAnalysisRecencyInsight: '近期洞察',
  exportAnalysisDetail: '匹配分析详情',
  emptyGuideTitle: '人才库暂时为空',
  emptyGuideDesc:
    '请前往领英使用EasyHireAI侧边栏，或在领英搜索页进行AI解析人才/领英个人主页绑定后回到人才库查看。',
  templateManagement: '打招呼模板管理',
  inMailTemplateManagement: 'InMail 模板管理',
  addTemplate: '添加模板',
  templateEmptyTitle: '暂无打招呼模板',
  templateEmptyDesc: '添加常用打招呼内容，发送时即可快速使用。',
  editTemplate: '编辑模板',
  selectTemplate: '选择',
  previewTemplate: '预览',
  templatePreview: '模板预览',
  templateTitle: '模板名称',
  templateContent: '模板内容',
  templateTitlePlaceholder: '请输入模板名称（如：通用打招呼）',
  templateContentPlaceholder: '请输入打招呼内容',
  inMailTemplateTitlePlaceholder: '请输入模板名称（如：初次沟通模板）',
  inMailTemplateContentPlaceholder: '请输入 InMail 模板内容',
  templateContentTooLong: '模板内容不能超过 {count} 字',
  confirmDeleteTemplate: '确定要删除该模板吗？',
  matchScore: '匹配度 {score}%',
  expandSearchFilters: '展开搜索筛选',
  collapseSearchFilters: '收起搜索筛选',
  dateYearMonth: '{year}年{month}月',
  summary: {
    profileTab: '人才画像',
    pipelineTab: '招聘流程与动态',
    detailTitle: '人员详情',
    tabSummary: 'AI分析总结',
    tabEducation: '教育背景',
    tabExperience: '工作经历',
    aiSummaryTitle: 'AI分析总结',
    aiKicker: 'AI 评估摘要',
    experienceKicker: '候选人履历',
    educationKicker: '学术背景',
    rating: 'RATING',
    resume: '原简历',
    coreInsight: '核心洞察',
    matchStrengths: '匹配优势',
    riskSignals: '风险提示',
    addComment: '添加面评',
    activityLog: '活动日志',
    pipelineTitle: '项目 / 流程',
    projectTitle: '项目',
    inProgress: '进行中',
    rollbackToStage: '回退至阶段',
    moveStageMenuTitle: '移动到阶段',
    pipelineFallback: '当前岗位',
    moveToStage: '移入下一阶段：{stage}',
    reachOut: '淘汰',
    stageSubmitted: '筛选中',
    stageScreening: '沟通中',
    stageRecommended: '推荐中',
    stageInterview: '面试环节',
    stageOffer: 'Offer 谈判',
    stageOnboard: 'Offer 待入职',
    stageArrived: '人才到岗',
    rejectScreening: '初筛淘汰',
    rejectInterview: '面试淘汰',
    rejectSalaryMismatch: '薪资谈不拢',
    rejectOfferDeclined: '放弃Offer',
    noteAdded: '添加了新的候选人记录',
    statusChanged: '阶段流转至「{status}」',
    systemGenerated: '系统',
    profileViewed: '打开了人才详情抽屉',
    timeUnknown: '时间未知',
    emptyRemark: '暂无备注信息',
    emptyRole: '暂无岗位信息',
    locationUnknown: '地区待补充',
    contactUnknown: '待补充',
    functionUnknown: '职能信息待补充',
    educationUnknown: '教育信息待补充',
    jobMatchTitle: '岗位匹配分析',
    aiScore: 'AI评分 {score} 分',
    skillAnalysisTitle: '技能分析',
    skillTags: '技能标签',
    emptyEducation: '暂无教育经历',
    emptyExperience: '暂无工作经历',
    mockNoData: '暂无结构化分析信息，当前为 MOCK 内容。',
    mockWorkYears: '工作年限约 {years} 年。',
    mockLatestCompany: '最近工作公司：{company}。',
    mockLatestRole: '最近岗位方向：{title}。',
    mockLocation: '候选人当前所在地：{location}。',
    strengthSkills: '技能栈覆盖 {skills}，与当前候选人画像高度吻合。',
    strengthYears: '累计约 {years} 年相关工作经验，可承担更高复杂度职责。',
    strengthExperienceDepth: '具备 {count} 段可追溯经历，履历连续性较好。',
    strengthChinaExperience: '具备中企工作背景，适合对本土协作有要求的岗位。',
    strengthLanguages: '语言能力覆盖 {languages}，跨区域协作潜力较强。',
    defaultStrength: '候选人基础资料完整，可继续结合面试进一步验证。',
    riskNoSummary: '简历摘要较少，建议在后续沟通中重点确认项目深度与职责边界。',
    riskNoDirectContact: '当前缺少直接联系方式，后续推进可能依赖站内触达或补采信息。',
    riskLimitedExperience: '结构化工作经历较少，建议结合原简历核对完整职业路径。',
    riskWorkStatusUnknown: '当前求职意向未明确，建议先确认近期看机会意愿。',
    riskBusinessGap:
      '过往经历与当前项目的具体业务场景可能存在部分断层，建议在后续面试中重点考察其实际落地案例。',
    candidateFallback: '该候选人',
    analysisFallback:
      '{name}具备较强的岗位相关经验，最近一段经历聚焦在{role}方向，核心产出集中于{company}相关业务场景。建议在后续沟通中继续核验项目深度、团队规模以及实际 ownership。',
    uploadedNewResume: '上传了新版简历',
    oneDayAgo: '1天前',
    fiveDaysAgo: '5天前',
    interviewInvitationRoundTwo: '面试邀请 - 二面',
    yesterdayAt: '昨天 14:30',
    interviewInvitationPreview:
      '您好，恭喜通过初试。我们想邀请您参加明天的技术二面，会议链接已发送至您的邮箱...',
    sentByName: '由 {name} 发送',
    resumeScreeningPassed: '简历筛选通过通知',
    threeDaysAgo: '3天前',
    resumeScreeningPreview:
      '感谢您投递高级前端开发工程师岗位，您的简历已通过初步筛选，HR 稍后会与您联系...',
    sentAutomatically: '系统自动发送',
    defaultStack: '前端工程、业务协作与交付推进',
    experienceFallback: '在 {company} 负责 {title} 相关工作，涉及 {stack} 等方向。',
    fallbackTag1: '销售',
    fallbackTag2: '海外拓展',
    fallbackTag3: '客户开发',
    recommendationReport: '推荐报告',
    recommendationReportExporting: '正在导出中',
    recommendationReportNotAvailable: '推荐报告导出失败，请稍后重试',
    assessmentReportNotAvailable: '暂未开放，敬请期待',
    reportTitle: 'AI 推荐报告',
    reportSubtitle: '岗位：{job}',
    generatedBy: '由 EasyHire AI 生成',
    reportName: '候选人推荐报告',
    reportBasicInfo: '基础信息',
    reportJobInfo: '岗位信息',
    reportDomain: 'Domain',
    reportExperienceSummary: '工作经历摘要',
    reportPosition: '职位',
    reportTime: '时间',
    reportSchool: '学校名称',
    reportEducationMajor: '学历/专业',
    scoreUnrated: '未评分',
    scoreStrongRecommend: '强推荐',
    scoreRecommend: '推荐',
    scoreAdvance: '可推进',
    scoreBackup: '备选',
    scoreCautious: '谨慎',
    scoreNotRecommend: '不推荐',
    candidateInfo: '候选人信息',
    candidateName: '姓名',
    currentRole: '当前职位',
    aiRating: 'AI 分析评分',
    recencyInsight: '近期动态',
    workYearsLabel: '工作年限',
    workYearsUnknown: '工作年限待补充',
    reportFooterTitle: 'EasyHire AI 候选人推荐报告',
    reportFooterSubtitle: '基于现有结构化数据生成',
  },
}

export default talent
